import { Divider, Typography } from "@mui/material";

interface Props {
  label: string;
  /** Omite el divider superior — usar en la primera sección de la card. */
  first?: boolean;
}

/**
 * Replica `.sub-h` + `.sub-divider` de styles.css (sección "premium fintech"):
 * encabezado de sub-sección dentro de una card, separado por un divider sutil.
 */
export const SectionHeader = ({ label, first }: Props) => (
  <>
    {/* `opacity` a propósito: dentro de una card la línea va más tenue que un separador normal. */}
    {!first && <Divider sx={{ mt: "20px", mb: "18px", opacity: 0.6 }} />}
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: "-0.01em",
        color: "primary.dark",
        mb: "12px",
      }}
    >
      {label}
    </Typography>
  </>
);
